$('.js-low-stock-tooltip').on('click', function () {
  var self = $(this);
  if (self.closest('.js-quick-add-wrap').length) {
    $(self).parent().siblings('.js-low-stock-tooltip-mobile').removeClass('d-none').html(self.find('.js-low-stock-tooltip-content').html());
    $(self).parents('.js-quick-add-wrap').siblings('.js-quick-add-wrap').find('.js-low-stock-tooltip-mobile').html(null);
  } else {
    $('.js-low-stock-tooltip-mobile').removeClass('d-none').html(self.find('.js-low-stock-tooltip-content').html());
  }
  if ($('.section-shop-more').length) {
    var cardParent = self.parents('.js-quick-add-wrap');
    var tooltipMobile = cardParent.find('.js-shop-more-tooltip-mobile');
    if (tooltipMobile.length) {
      var allToolTipMobile = cardParent.parents('.section').find('.js-shop-more-tooltip-mobile');

      // Hide all tooltip mobile within the section
      if (allToolTipMobile.length) {
        allToolTipMobile.removeClass("d-flex d-lg-none").addClass('d-none');
      }

      // Show tooltip for the specific card
      if (self.find('.js-low-stock-tooltip-content').html()) {
        tooltipMobile.addClass("d-flex d-lg-none").removeClass('d-none');
      }
    }
  }
});

// $('.js-low-stock-quick-add').on('click', function (e) {
//   let self = $(this);

//   e.preventDefault();

//   $(self).parent().siblings('.js-low-stock-tooltip-mobile').removeClass('d-none').html(self.find('.js-low-stock-tooltip-content').html());
//   $(self).parents('.js-quick-add-wrap').siblings('.js-quick-add-wrap').find('.js-low-stock-tooltip-mobile').html(null)

// });

$(document).on('click', function (e) {
  if (e.target.closest('.js-low-stock-tooltip') || e.target.closest('.js-low-stock-quick-add')) return;
  $('.js-low-stock-tooltip-mobile').html(null);
  $('.js-low-stock-tooltip-mobile').addClass('d-none');

  // Hide all tooltip mobile within the section
  var allToolTipMobile = $('.section-shop-more').find('.js-shop-more-tooltip-mobile');
  if (allToolTipMobile.length) {
    allToolTipMobile.removeClass("d-flex d-lg-none").addClass('d-none');
  }
});


// WEBPACK FOOTER //
// ./scripts/components/low-stock.js